import { cloneDeep, get, isObject, isArray, set, transform } from "lodash";
const defaultRedactOptions = {
  sensitiveKeys: ["firstName", "lastName", "gender", "email", "phoneNumber"],
  redactedValue: "[REDACTED]"
};
const redactSensitiveKeys = (response, options) => {
  const clonedResponse = cloneDeep(response);
  const parsedKeys = [];
  const { sensitiveKeys, redactedValue } = options || defaultRedactOptions;
  const parseAndRedactRecursive = (data, currentKey) => {
    if (isObject(data) || isArray(data)) {
      return transform(data, (result, value, key) => {
        const newKey = currentKey ? `${currentKey}.${key}` : key;
        if (sensitiveKeys.includes(key)) {
          result[key] = redactedValue;
        } else {
          const parsedValue = parseValue(value);
          if (parsedValue !== value) {
            result[key] = parsedValue;
            parsedKeys.push(newKey);
          } else {
            result[key] = parseAndRedactRecursive(value, newKey);
          }
        }
      });
    } else {
      return data;
    }
  };
  const parseValue = (value) => {
    try {
      const parsedData = JSON.parse(value);
      if (isObject(parsedData)) {
        return redactSensitiveKeys(parsedData, options);
      } else {
        return value;
      }
    } catch (error) {
      return value;
    }
  };
  const redactedResponse = parseAndRedactRecursive(clonedResponse, "");
  return stringifyBackParsedKeys(redactedResponse, parsedKeys);
};
const stringifyBackParsedKeys = (redactedResponse, parsedKeys) => {
  if (parsedKeys.length) {
    parsedKeys.forEach((key) => {
      const value = get(redactedResponse, key);
      if (isObject(value) || isArray(value)) {
        set(redactedResponse, key, JSON.stringify(value));
      }
    });
  }
  return redactedResponse;
};
export {
  redactSensitiveKeys
};
